module.exports = __webpack_public_path__ + "static/media/linkedin.d6ca9cfb.png";